import { render } from "./EditOrgane.vue?vue&type=template&id=58e1f494&ts=true"
import script from "./EditOrgane.vue?vue&type=script&lang=ts"
export * from "./EditOrgane.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__